/**
 * Module to boot the system
 */
define('index',[
        'durandal/system', 'durandal/app', 'durandal/viewLocator', 'atn/atn',
        'customPlugins/atnCustomDialog/initAtnCustomDialog', 'knockout',
        'common/utils', './pluginLoader', './ie10WindowPhoneFix'
    ],
    /**
     * boots the application
     * @param  {object} system       ko.system
     * @param  {object} app          ko.app
     * @param  {object} viewLocator  ko.viewLocator
     * @return {[undefined]}
     */
    function(system, app, viewLocator, atn, initAtnCustomDialog, ko, utils, pluginLoader, ie10WindowPhoneFix) {
        'use strict';

        init();

        function init() {
            //>>excludeStart("build", true);
            system.debug(true);
            //>>excludeEnd("build");

            app.title = 'Operations Insights';

            app.configurePlugins({
                router: true,
                dialog: true,
                widget: true
            });

            app.start().then(function() {
                //Replace 'viewmodels' in the moduleId with 'views' to locate the view.
                //Look for partial views in a 'views' folder in the root.
                viewLocator.useConvention();

                initAtnCustomDialog();

                //Show the app by setting the root view model for our application with a transition.
                app.setRoot('viewmodels/shell');
            });
        }
    });
